import { FC, useState } from 'react';

import { useTranslation } from 'react-i18next';
import styles from './TruncatedText.module.scss';

interface TruncatedTextProps {
  text: string;
  maxLength?: number;
  className?: string;
}

const TruncatedText: FC<TruncatedTextProps> = ({
  text,
  maxLength = 300,
  className
}) => {
  const { t } = useTranslation()
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) {
    return null;
  }

  const shouldTruncate = text.length > maxLength;
  const displayText =
    shouldTruncate && !isExpanded ? text.slice(0, maxLength) + '...' : text;

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={className}>
      <div className={styles.text}>{displayText}</div>
      {shouldTruncate && (
        <button className={styles.toggleButton} onClick={handleToggle}>
          {isExpanded ? t('job.viewLess') : t('job.viewMore')}
        </button>
      )}
    </div>
  );
};

export default TruncatedText;
